<template>
  <main class="main-home flex min-h-[calc(100vh-88px)] items-center justify-center px-4 py-10">
    <section class="w-full max-w-3xl">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <router-link
          v-for="item in primaryMenus"
          :key="item.name"
          :to="{ name: item.name }"
          class="primary-card"
        >
          <span class="text-6xl leading-none sm:text-7xl" aria-hidden="true">{{ item.emoji }}</span>
          <span class="mt-5 text-2xl font-black text-white sm:text-3xl">{{ item.label }}</span>
        </router-link>
      </div>
      <div class="mx-auto mt-5 grid max-w-lg grid-cols-2 gap-3">
        <router-link
          v-for="item in secondaryMenus"
          :key="item.name"
          :to="{ name: item.name }"
          class="secondary-card"
        >
          <span class="text-2xl leading-none" aria-hidden="true">{{ item.emoji }}</span>
          <span class="text-sm font-black text-slate-100 sm:text-base">{{ item.label }}</span>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'MainView',
  data() {
    return {
      primaryMenus: [
        { name: 'lotto', label: '로또번호추천', emoji: '🎱' },
        { name: 'fortuneCookie', label: '포춘쿠키', emoji: '🥠' },
      ],
      secondaryMenus: [
        { name: 'tangtangball', label: '탱탱볼', emoji: '🏐' },
        { name: 'boardList', label: '게시판', emoji: '📋' },
      ],
    };
  },
};
</script>

<style scoped>
.main-home {
  background:
    radial-gradient(circle at 18% 12%, rgba(30, 200, 255, 0.18), transparent 28rem),
    radial-gradient(circle at 88% 80%, rgba(255, 92, 138, 0.12), transparent 26rem),
    linear-gradient(160deg, #080f1a 0%, #101a2a 52%, #0d2236 100%);
}

.primary-card,
.secondary-card {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(17, 26, 39, 0.88);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.28);
  transition:
    transform 160ms ease,
    border-color 160ms ease,
    background-color 160ms ease;
}

.primary-card {
  min-height: 240px;
  flex-direction: column;
  border-radius: 32px;
  padding: 2rem 1.5rem;
}

.secondary-card {
  min-height: 72px;
  gap: 0.6rem;
  border-radius: 18px;
  padding: 0.9rem 1rem;
}

.primary-card:hover,
.secondary-card:hover {
  transform: translateY(-3px);
  border-color: rgba(30, 200, 255, 0.45);
  background: rgba(22, 40, 61, 0.95);
}
</style>
